import { operatorEvents } from "@/operator/events/operatorEvents";

import { BaseController } from "./BaseController";

export class OpenBillsController extends BaseController {
    constructor() {
        super("open-bills");
    }

    protected onBecomeVisible() {
        operatorEvents.openBillsController.onShown.dispatch();
    }

    protected onBecomeInvisible() {
        setTimeout(() => {
            operatorEvents.openBillsController.onHidden.dispatch();
        }, 500);
    }
}
